module.exports = __webpack_public_path__ + "img/whyRed.b7a55a8c.jpg";